/* Menú desplegable de Categorías y submenús del encabezado */
(function () {
  function init() {
    var dropdowns = document.querySelectorAll('[data-nav-dropdown]');
    var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    function setOpen(item, open) {
      item.classList.toggle('is-open', open);
      var btn = item.querySelector('.nav-item__toggle');
      if (btn) btn.setAttribute('aria-expanded', String(open));
    }
    function closeAll(except) {
      dropdowns.forEach(function (d) { if (d !== except) setOpen(d, false); });
    }
    dropdowns.forEach(function (item) {
      var btn = item.querySelector('.nav-item__toggle');
      var timer;
      if (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var open = canHover ? true : !item.classList.contains('is-open');
          closeAll(item);
          setOpen(item, open);
        });
      }
      if (canHover) {
        item.addEventListener('mouseenter', function () { clearTimeout(timer); closeAll(item); setOpen(item, true); });
        item.addEventListener('mouseleave', function () { timer = setTimeout(function () { setOpen(item, false); }, 180); });
      }
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) setOpen(item, false);
      });
    });
    if (dropdowns.length) {
      document.addEventListener('click', function (e) {
        if (!e.target.closest('[data-nav-dropdown]')) closeAll();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          var openItem = document.querySelector('[data-nav-dropdown].is-open');
          closeAll();
          if (openItem) { var b = openItem.querySelector('.nav-item__toggle'); if (b) b.focus(); }
        }
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
